import { logger } from "../../../../../utils/logger";
/*
  課題・障害番号: なし
  対応日: 2026/3/27
  担当者: 石川
  修正概要: エラー画面を追加
*/
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchAuthSession, signOut } from "aws-amplify/auth";

const ErrorPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const errorInfo = location.state;

  const [isSessionValid, setIsSessionValid] = useState(null);

  useEffect(() => {
    const checkSession = async () => {
      try {
        await fetchAuthSession();
        setIsSessionValid(true);
      } catch (e) {
        if (e.name === "NotAuthorizedException") {
          await signOut({ global: false });
          setIsSessionValid(false);
        } else {
          setIsSessionValid(true);
        }
      }
    };

    checkSession();
  }, []);

  // 1つ前の画面へ
  const goBack = () => navigate(-1);
  const goLogin = async () => {
    try {
      await signOut();
    } catch (e) {
      logger.error("signOut error:", e);
    }
    /*
      課題・障害番号: 安定化
      対応日: 2026/5/13
      担当者: 越智
      修正概要: システムエラー画面からログイン画面へ復帰
    */
    // ログイン画面へ
    window.ReactNativeWebView?.postMessage(JSON.stringify({ type: "RESET_WEBVIEW" }));
    // WebView でない（PCブラウザ）場合はフォールバックで SPA 遷移
    if (
      typeof window === "undefined" ||
      !window.ReactNativeWebView ||
      typeof window.ReactNativeWebView.postMessage !== "function"
    ) {
      navigate("/");
    }
    /*
      END
      課題・障害番号: 安定化
    */
  };

  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h2>システムエラーが発生しました</h2>
      <h2>
        再ログインしても改善しない場合は
        <br />
        管理者へ連絡してください
      </h2>

      {errorInfo?.message && (
        <h1 style={{ color: "red" }}>
          {errorInfo.message}
          {errorInfo?.keyword && (
            <>
              <br />
              問い合わせコード: {errorInfo.keyword}
            </>
          )}
        </h1>
      )}

      {/* セッション判定中は何も表示しない */}
      {isSessionValid !== null && (
        <>
          {isSessionValid && (
            <button
              onClick={goBack}
              style={{ fontSize: "1.1rem", padding: "0.6em 1.2em", marginRight: "1rem" }}
            >
              前の画面へ戻る
            </button>
          )}

          <button
            onClick={goLogin}
            style={{ fontSize: "1.1rem", padding: "0.6em 1.2em" }}
          >
            ログイン画面へ
          </button>
        </>
      )}
    </div>
  );
};

export default ErrorPage;
